import { Component, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-mobile-filter-dialog',
  templateUrl: './mobile-filter-dialog.html',
  imports: [FormsModule, TranslatePipe],
})
export class MobileFilterDialog {
  public articleAmount = input.required<number>()

  protected resetFilters = output()

  protected isDialogVisible = false

  protected closeDialog(): void {
    this.isDialogVisible = false
  }

  protected showDialog(): void {
    this.isDialogVisible = true
  }
}
